"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearUserSettingsService = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var api_1 = require("../../utils/api");
var constants_1 = require("../constants");
var BearUserSettingsService = /** @class */ (function () {
    function BearUserSettingsService(authCall) {
        this.authCall = authCall;
    }
    BearUserSettingsService.prototype.getSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.authCall(function (sdk, _a) {
                        var getPrincipal = _a.getPrincipal;
                        return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var userLoginMd5, _b, flags, currentProfile, separators, language;
                            return tslib_1.__generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, api_1.userLoginMd5FromAuthenticatedPrincipalWithAnonymous(getPrincipal)];
                                    case 1:
                                        userLoginMd5 = _c.sent();
                                        // for anonymous users, return defaults
                                        if (!userLoginMd5) {
                                            return [2 /*return*/, constants_1.ANONYMOUS_USER_SETTINGS];
                                        }
                                        return [4 /*yield*/, Promise.all([
                                                sdk.user.getUserFeatureFlags(userLoginMd5),
                                                sdk.user.getCurrentProfile(),
                                                sdk.user.getUserRegionalNumberFormatting(userLoginMd5),
                                            ])];
                                    case 2:
                                        _b = _c.sent(), flags = _b[0], currentProfile = _b[1], separators = _b[2];
                                        language = currentProfile.language;
                                        return [2 /*return*/, tslib_1.__assign({ userId: userLoginMd5, locale: language, separators: separators }, flags)];
                                }
                            });
                        });
                    })];
            });
        });
    };
    BearUserSettingsService.prototype.setLocale = function (_locale) {
        throw new sdk_backend_spi_1.NotSupported("Backend does not support user locale setup");
    };
    return BearUserSettingsService;
}());
exports.BearUserSettingsService = BearUserSettingsService;
//# sourceMappingURL=settings.js.map